import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";
import Cards from "./Cards";
import MyCard from "./MyCard";
import AllMyCardTransactions from "./AllMyCardTransactions";
import Withdraw from "./Withdraw";
import Fund from "./Fund";
import RequestCard from "./RequestCard";
import RequestPhysicalCard from "./RequestPhysicalCard";

const CardsRoot = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={Cards} />
      <ProtectedRoute
        exact
        path={`${path}/preorder`}
        component={RequestPhysicalCard}
      />
      <ProtectedRoute exact path={`${path}/request`} component={RequestCard} />
      <ProtectedRoute exact path={`${path}/:id`} component={MyCard} />
      <ProtectedRoute
        exact
        path={`${path}/:id/transactions`}
        component={AllMyCardTransactions}
      />
      <ProtectedRoute
        exact
        path={`${path}/:id/withdraw`}
        component={Withdraw}
      />
      <ProtectedRoute exact path={`${path}/:id/fund`} component={Fund} />
    </Switch>
  );
};

export default CardsRoot;
